export { default as useCacheMaterials } from './useCacheMaterials';
